import { DEFAULT_DETAILS_CONTEXT } from './HotelDetails.context';
export var HotelDetailsActionType;
(function (HotelDetailsActionType) {
    HotelDetailsActionType["SET_SCROLL_TARGET"] = "set-scroll-target";
    HotelDetailsActionType["SET_MOBILE_DRAWER_OPEN"] = "set-mobile-drawer-open";
    HotelDetailsActionType["SET_PRICING_CALENDAR_INITIAL_LOAD"] = "set-pricing-calendar-initial-load";
    HotelDetailsActionType["SET_PRICING_CALENDAR_TOGGLE"] = "set-pricing-calendar-toggle";
    HotelDetailsActionType["SET_SCROLL_TO_SECTION"] = "set-sroll-to-section";
    HotelDetailsActionType["RESET_CONTEXT"] = "reset-context";
})(HotelDetailsActionType || (HotelDetailsActionType = {}));
export function hotelDetailsReducer(state, action) {
    switch (action.type) {
        case HotelDetailsActionType.SET_MOBILE_DRAWER_OPEN:
            return Object.assign(Object.assign({}, state), { isMobileDrawerOpen: action.payload });
        case HotelDetailsActionType.SET_PRICING_CALENDAR_INITIAL_LOAD:
            return Object.assign(Object.assign({}, state), { pricingCalendarInitialLoad: action.payload });
        case HotelDetailsActionType.SET_PRICING_CALENDAR_TOGGLE:
            return Object.assign(Object.assign({}, state), { showPricingCalendar: action.payload });
        case HotelDetailsActionType.SET_SCROLL_TO_SECTION:
            return Object.assign(Object.assign({}, state), { onScrollToSection: action.payload });
        case HotelDetailsActionType.RESET_CONTEXT:
            return Object.assign(Object.assign({}, DEFAULT_DETAILS_CONTEXT), { onScrollToSection: state.onScrollToSection });
        default:
            return state;
    }
}
